import { City, District, Province } from 'generated/graphql'
import React from 'react'

import { SearchTab } from 'types'
import { Link, Skeleton, GridProps, Box, Stack, SimpleGrid, Flex } from '@chakra-ui/react'
import { useHistory } from 'react-router'
import { useAuthContext } from 'context/AuthProvider'
import { initialValues, useAppContext } from 'context/AppProvider'
import { FooterHeading } from 'components/Footer/FooterHeading'

type ProvinceGridProps = {
  provinces?: Province[]
  cities?: City[]
  districts?: District[]
  loading: boolean
  slug: string
} & GridProps

const LIMIT = 6
const ProvinceGrid = React.forwardRef<HTMLDivElement, ProvinceGridProps>(
  ({ provinces, loading, slug, cities, districts, ...rest }, ref) => {
    const history = useHistory()
    const { isAuthenticated } = useAuthContext()
    const { setsearchFilters } = useAppContext()

    return (
      <SimpleGrid fontSize="sm" rowGap={10} my={10} columns={[2, 3, 4]} ref={ref} {...rest}>
        {provinces &&
          provinces?.slice(0, LIMIT)?.map((province) => (
            <Box minW="130px" key={province?.id}>
              <FooterHeading mb="4">
                <Flex align="center">
                  <Link
                    fontSize="xs"
                    onClick={() => {
                      setsearchFilters(initialValues)
                      history.push(
                        isAuthenticated
                          ? `/auth/simple-search/${slug}/${province.slug}`
                          : `/simple-search/${slug}/${province.slug}`,
                        {
                          province,
                          slug,
                          name: province?.name as string,
                          _key: `${province?.id}${province?.__typename}`,
                          id: province?.id as string,
                          typename: province?.__typename
                        } as SearchTab
                      )
                    }}
                  >
                    {province?.name}
                  </Link>
                </Flex>
              </FooterHeading>
              <Stack>
                {province?.districts?.slice(0, LIMIT)?.map((district) => (
                  <Skeleton key={district?.id} isLoaded={!loading}>
                    <Link
                      onClick={() => {
                        setsearchFilters(initialValues)
                        history.push(
                          isAuthenticated
                            ? `/auth/simple-search/${slug}/${province.slug}/${district?.slug}`
                            : `/simple-search/${slug}/${province.slug}/${district?.slug}`,
                          {
                            district,
                            slug,
                            name: district?.name as string,
                            _key: `${district?.id}${district?.__typename}`,
                            id: district?.id as string,
                            typename: district?.__typename
                          } as SearchTab
                        )
                      }}
                    >
                      {district?.name}
                    </Link>
                  </Skeleton>
                ))}
              </Stack>
            </Box>
          ))}

        {districts &&
          districts?.slice(0, LIMIT)?.map((district) => (
            <Box minW="130px" key={district?.id}>
              <FooterHeading mb="4">
                <Flex align="center">
                  <Link
                    fontSize="xs"
                    onClick={() => {
                      setsearchFilters(initialValues)
                      history.push(
                        isAuthenticated
                          ? `/auth/simple-search/${slug}/${district?.province?.slug}/${district?.slug}`
                          : `/simple-search/${slug}/${district?.province?.slug}/${district?.slug}`,
                        {
                          district,
                          slug,
                          name: district?.name as string,
                          _key: `${district?.id}${district?.__typename}`,
                          id: district?.id as string,
                          typename: district?.__typename
                        } as SearchTab
                      )
                    }}
                  >
                    {district?.name}
                  </Link>
                </Flex>
              </FooterHeading>
              <Stack>
                {district?.cities?.slice(0, LIMIT)?.map((city) => (
                  <Skeleton key={city?.id} isLoaded={!loading}>
                    <Link
                      onClick={() => {
                        setsearchFilters(initialValues)
                        history.push(
                          isAuthenticated
                            ? `/auth/simple-search/${slug}/${district?.province?.slug}/${district?.slug}/${city?.slug}`
                            : `/simple-search/${slug}/${district?.province?.slug}/${district?.slug}/${city?.slug}`,
                          {
                            city,
                            slug,
                            name: city?.name as string,
                            _key: `${city?.id}${city?.__typename}`,
                            id: city?.id as string,
                            typename: city?.__typename
                          } as SearchTab
                        )
                      }}
                    >
                      {city?.name}
                    </Link>
                  </Skeleton>
                ))}
              </Stack>
            </Box>
          ))}
        {cities &&
          cities?.slice(0, LIMIT)?.map((city) => (
            <Box minW="130px" key={city?.id}>
              <FooterHeading mb="4">
                <Flex align="center">
                  <Link
                    fontSize="xs"
                    onClick={() => {
                      setsearchFilters(initialValues)
                      history.push(
                        isAuthenticated
                          ? `/auth/simple-search/${slug}/${city?.district?.province?.slug}/${city?.district?.slug}/${city.slug}`
                          : `/simple-search/${slug}/${city?.district?.province?.slug}/${city?.district?.slug}/${city.slug}`,
                        {
                          city,
                          slug,
                          name: city?.name as string,
                          _key: `${city?.id}${city?.__typename}`,
                          id: city?.id as string,
                          typename: city?.__typename
                        } as SearchTab
                      )
                    }}
                  >
                    {city?.name}
                  </Link>
                </Flex>
              </FooterHeading>
              <Stack>
                {city?.suburbs?.slice(0, LIMIT)?.map((suburb) => (
                  <Skeleton key={suburb?.id} isLoaded={!loading}>
                    <Link
                      onClick={() => {
                        setsearchFilters(initialValues)
                        history.push(
                          isAuthenticated
                            ? `/auth/simple-search/${slug}/${city?.district?.province?.slug}/${city?.district?.slug}/${city?.slug}/${suburb?.slug}`
                            : `/simple-search/${slug}/${city?.district?.province?.slug}/${city?.district?.slug}/${city?.slug}/${suburb?.slug}`
                        )
                      }}
                    >
                      {suburb?.name}
                    </Link>
                  </Skeleton>
                ))}
              </Stack>
            </Box>
          ))}
      </SimpleGrid>
    )
  }
)

export default ProvinceGrid
